const BACKGROUND = {
  CLOUD: {
    animation: 'CLOUD',
    width: 64,
    height: 64,
    spriteX: 166,
    spriteY: 2
  },
  HORIZON: {
    animation: 'HORIZON',
    width: 700,
    height: 20,
    spriteX: 2,
    spriteY: 104
  },
  MOON: {
    animation: 'MOON',
    width: 954,
    height: 64,
    spriteX: 2,
    spriteY: 104
  },
  STAR: {
    animation: 'STAR',
    width: 64,
    height: 64,
    spriteX: 1276,
    spriteY: 104
  }
};

export default BACKGROUND;
